const { download } = require('utilities/fileDownloadHelper');
const { base64ToBlob } = require('utilities/APIRequestHelper');
const getExtension = require('utilities/mimeTypeToExt');

const openTabOrSave = (base64, contentType, documentName) => {
    try {
        const binaryImg = atob(base64);
        const length = binaryImg.length;
        const arrayBuffer = new ArrayBuffer(length);
        const uintArray = new Uint8Array(arrayBuffer);
        for (let i = 0; i < length; i++) {
            uintArray[i] = binaryImg.charCodeAt(i);
        }
        const currentBlob = new Blob([uintArray], { type: 'application/pdf' });
        const linkRoute = URL.createObjectURL(currentBlob);
        if (!window.open(linkRoute, '_blank')) {
            throw 'Pop-up blocked';
        }
    } catch (e) {
        const base64stringData = `data:${contentType};base64,${base64}`;
        const b64toBlobResponse = base64ToBlob(base64stringData);
        const fileExtension = getExtension(contentType);
        download(b64toBlobResponse, `${documentName}.${fileExtension}`, contentType);
    }
};

module.exports = {
    openTabOrSave
}